#@import CLNDR
#@import moment
#@import GliveBooking.Collections.Times
#@import GliveBooking.Collections.Sections
#@import GliveBooking.Collections.Prices
#@import GliveBooking.Collections.Events
#@import GliveBooking.FilteredCollections.Events
#@import GliveBooking.Models.Section
#@import GliveBooking.Models.Price
#@import GliveBooking.Models.Event
#@export GliveBooking.Models.Booker

class GliveBooking.Models.Booker extends BookingV2.Models.Base

  loaded: true

  initialize: ->
    try
      unless @get('gliveAvailabilityHash')?.events?
        throw "Invalid availability data"

      eventsCollection = new GliveBooking.Collections.Events(@get('gliveAvailabilityHash').events)
      filteredEventsCollection = new GliveBooking.FilteredCollections.Events(eventsCollection)
      isSoldOut = @get('gliveAvailabilityHash').product.isSoldOut
      isAvailable = filteredEventsCollection.length > 0

      times = @uniquifyAndSortTimes(filteredEventsCollection.getTimes())
      sections = @uniquifySections(filteredEventsCollection.getSections())
      prices = @uniquifyPrices(filteredEventsCollection.getPrices())
      isTouchRequest= @get('isTouchRequest')

      @set
        isSoldOut: isSoldOut
        isAvailable: isAvailable
        isSellable: !isSoldOut and isAvailable
        events: eventsCollection
        filteredEvents: filteredEventsCollection
        dates: new BookingV2.Collections.Availability(filteredEventsCollection.getDates())
        times: new GliveBooking.Collections.Times(times)
        quantities: new BookingV2.Collections.PartySizes(filteredEventsCollection.getQuantities())
        sections: new GliveBooking.Collections.Sections(sections)
        prices: new GliveBooking.Collections.Prices(prices)
        isTouch: isTouchRequest

      @get('dates').meta('loaded', true)
      @get('times').meta('loaded', true)

      @get('events').meta('isTouch', @get('isTouchRequest'))
      @get('dates').meta('isTouch', @get('isTouchRequest'))
      @get('times').meta('isTouch', @get('isTouchRequest'))
      @get('quantities').meta('isTouch', @get('isTouchRequest'))
      @get('sections').meta('isTouch', @get('isTouchRequest'))
      @get('prices').meta('isTouch', @get('isTouchRequest'))

    catch error
      console.error error
      if error == "Invalid availability data"
        @setError('loading')

  setError: (error) ->
    @set {error}

  clearError: ->
    @unset 'error'

  getError: ->
    @get 'error'

  uniquifyAndSortTimes: (timesArray) ->
    times = _.uniq(timesArray, (time) ->
      time.start().format('LT') # determine uniqueness based on time string
    )
    times = _.sortBy(times, (time) ->
      time.start().format("HH mm")
    )

  uniquifySections: (sectionsArray) ->
    sections = _.uniq(sectionsArray, (section) ->
      section.getTitle()
    )

  uniquifyPrices: (pricesArray) ->
    prices = _.uniq(pricesArray, (price) ->
      price.getPrice()
    )

  getEvents: ->
    @get('events')

  requirePhone: ->
    false

  requireQuestion: ->
    false

  discountEnabled: ->
    @get('deal').discountEnabled

  reset: ->
    @resetTime()

  resetDate: ->
    @selectDate null

  resetTime: ->
    @selectTime null

  updateAllPickers: ->
    dates = @get('filteredEvents').getDates()
    @get('dates').reset(dates)

    times = @uniquifyAndSortTimes(@get('filteredEvents').getTimes())
    @get('times').reset(times)

    quantities = @get('filteredEvents').getQuantities()
    @get('quantities').reset(quantities)

    prices = @uniquifyPrices(@get('filteredEvents').getPrices())
    @get('prices').reset(prices)

    sections = @uniquifySections(@get('filteredEvents').getSections())
    @get('sections').reset(sections)

    @trigger "updatedCollections"

  selectDate: (selection) ->
    events = []
    if selection?
      {events, date} = selection
      selectedDate = {date}
      selectedEventTime = events[0].initialTimeMoment

    @set {selectedDate}
    @get('filteredEvents').setDateFilter(selectedEventTime)
    @updateAllPickers()

  selectTime: (time) ->
    @set selectedTime: time
    @get('filteredEvents').setTimeFilter(time)
    @updateAllPickers()

  selectPrice: (price) ->
    @set selectedPrice: price
    @get('filteredEvents').setPriceFilter(price)
    @updateAllPickers()

  selectSection: (section) ->
    @set selectedSection: section
    @get('filteredEvents').setSectionFilter(section)
    @updateAllPickers()

  selectQuantity: (quantity) ->
    @set selectedQuantity: quantity
    @get('filteredEvents').setQuantityFilter(quantity.getPartySize())
    @updateAllPickers()

  clearAll: ->
    @get('filteredEvents').resetFilters()
    @updateAllPickers()
    @set selectedDate: {date: null}
    @set selectedTime: null
    @set selectedQuantity: null
    @set selectedSection: null
    @set selectedPrice: null
    @updateAllPickers()
    @trigger "clearAll"

  isReadyToBook: ->
    @get('selectedDate')?.date? and @get('selectedTime')? and @get('selectedQuantity')? and @get('selectedPrice')? and @get('selectedSection')?

  checkoutUrl: ->
    permalink = @get('deal').id
    event_uuid = @get('filteredEvents').first().getUUID()
    quantity = @get('selectedQuantity').getPartySize()
    "/live/deals/#{permalink}/reservation?event=#{event_uuid}&quantity=#{quantity}"

  book: ->
    window.location.href = @checkoutUrl()
